import type { Contact } from '@app/services/api.types';
import { fn } from '@app/utils';
import { url } from '@app/utils/constants';
import {
    Descriptions,
    Divider,
    Drawer,
    Flex,
    type DescriptionsProps,
    type DrawerProps,
} from 'antd';
import { Link } from 'react-router';

export type ContactDrawerProps = DrawerProps & {
    data: Contact | null;
};

export const ContactDrawer = ({ data, ...props }: ContactDrawerProps) => {
    const detailsItems: DescriptionsProps['items'] = [
        {
            key: '1',
            label: 'Most Recent Interaction',
            children: data?.most_recent_interaction
                ? fn.formatDate(data?.most_recent_interaction, 'DD/MM/YYYY, HH:mm:ss')
                : '-',
        },
        {
            key: '2',
            label: 'Total Interactions',
            children: (
                <Flex align="baseline" gap={8}>
                    {data?.total_interactions || '-'}
                    {data?.total_interactions ? (
                        <Link
                            to={{
                                pathname: url.adminPortal.interactions,
                                search: `?contact_id=${data?.id}`,
                            }}
                            className="link"
                            title="View Interactions"
                            style={{
                                fontSize: 12,
                            }}>
                            View All
                        </Link>
                    ) : null}
                </Flex>
            ),
        },
    ];

    const contactItems: DescriptionsProps['items'] = [
        {
            key: '1',
            label: 'Name',
            children: [data?.first_name, data?.last_name].filter(Boolean).join(' ') || '-',
        },
        {
            key: '2',
            label: 'Phone',
            children: data?.telephone || '-',
        },
        {
            key: '3',
            label: 'Email',
            children: data?.email || '-',
        },
    ];

    const renderDetailsTab = () => {
        return (
            <>
                <Descriptions
                    title="Details"
                    colon={false}
                    layout="vertical"
                    items={contactItems}
                    column={2}
                />
                <Divider />
                <Descriptions
                    title="Interactions"
                    colon={false}
                    layout="vertical"
                    items={detailsItems}
                    column={2}
                />
            </>
        );
    };

    return (
        <Drawer
            title={
                <>
                    <span>Contact Details</span>
                    {data?.id ? (
                        <div className="ant-drawer-header-meta">
                            <span>ID: {data?.id}</span>
                        </div>
                    ) : null}
                </>
            }
            size={700}
            closable={{ 'aria-label': 'Close Button' }}
            {...props}>
            {renderDetailsTab()}
        </Drawer>
    );
};

export default ContactDrawer;
